/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import { Form, DatePicker, Col, } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import moment from 'moment';
import Button from '../../button';
// import { getValidationRules } from '../../../../utils/validations';
import Input from '../../input';

const { Item } = Form;
const dateFormat = 'DD/MM/YYYY';
const FormCosecha = ({
  onSubmit, initialValues, cropprofile
}) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    const newAcontecimiento = {
      ...values,
      campaña: cropprofile?.campaña?._id,
      perfilcultivo: cropprofile?._id,
      fecha: new Date(values?.fecha?.$d)
    };
    onSubmit(newAcontecimiento);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onFinish(values);
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      ...initialValues,
    });
  }, [initialValues]);

  const disabledDate = (current) => current && current > moment().endOf('day');
  return (
    <Form form={form} layout="vertical">
      <Col offset={6}>
        <Item label="Fecha" name="fecha" colon={false}>
          <DatePicker
            style={{ width: '100%' }}
            format={dateFormat}
            disabledDate={disabledDate}
          />
        </Item>
        <Item label="Gramos" name="gramos" colon={false}>
          <Input />
        </Item>
        <Item label="Comentarios" name="comentarios" colon={false}>
          <Input />
        </Item>
      </Col>
      <div className="container-page__center-buttons">
        <Button type="primary" onClick={handleSubmit} text="Guardar" />
      </div>
    </Form>

  );
};
FormCosecha.propTypes = {
  initialValues: PropTypes.shape(),
  cropprofile: PropTypes.shape(),
  onSubmit: PropTypes.func,
};
FormCosecha.defaultProps = {
  onSubmit: () => {},
  cropprofile: {},
  initialValues: {}
};

export default FormCosecha;
